<template>
  <v-card>
    <v-card>
      <v-form ref="Addform" v-model="valid">
        <v-toolbar color="#050048" dark flat dense>
          <span>Update Rate</span>
          <v-spacer></v-spacer>
          <v-btn depressed icon @click="closeDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <label class="my-0 rounded labelFontsize required">
                Country
              </label>
              <v-autocomplete
                class="rounded"
                dense
                v-model="country_ratedata.country"
                outlined
                placeholder="Country"
                item-text="txt"
                item-value="val"
                disabled
                :items="country_options"
                :rules="FieldRequired('Country')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="12">
              <label class="my-0 rounded labelFontsize required">
                Currency
              </label>
              <v-text-field
                class="rounded"
                dense
                disabled
                v-model="country_ratedata.currency_code"
                outlined
                placeholder="Currency"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <label class="my-0 rounded labelFontsize required">
                Cost Rate
              </label>
              <v-text-field
                class="rounded"
                v-model="country_ratedata.buy_rate"
                dense
                outlined
                type="number"
                hide-spin-buttons
                placeholder="Cost Rate"
                item-text="txt"
                item-value="val"
                @keydown="filterNumberInput"
                :rules="FieldNumbRequired('Cost Rate')"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider class="pa-0 mb-0"></v-divider>
        <v-card-actions class="ma-0 pt-0">
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
            color="primary"
            @click="update()"
            ><v-icon small>mdi-content-save-plus-outline</v-icon>
            Update
          </v-btn>
          <v-btn
            depressed
            small
            class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
            color="primary"
            outlined
            @click="closeDialog()"
            ><v-icon small>mdi-close-circle-outline</v-icon>cancel
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-card>
</template>

<script>
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
import alerts from "@/mixins/alerts";
export default {
  name: "Update Cost Schedule",
  mixins: [alerts],
  data() {
    return {
      FieldRequired,
      FieldNumbRequired,
      valid: true,
      country_options: [],
      country_object: [],
      country_ratedata: {
        country: null,
        buy_rate: 0,
        sell_rate: 0,
        currency_code: null,
        rate_difference: 0,
        rate_level: "CW",
      },
    };
  },
  props: {
    selectedUpdateRate: {
      type: Object,
    },
  },

  mounted() {
    this.getBeneCountryList();
  },
  methods: {
    async update() {
      this.loader = true;
      const payload = {
        buy_rate: this.country_ratedata.buy_rate,
        sell_rate: this.country_ratedata.buy_rate,
        previous_balance: this.selectedUpdateRate.previous_balance,
        current_balance: this.selectedUpdateRate.current_balance,
        previous_rate: this.selectedUpdateRate.previous_rate,
        current_rate: this.selectedUpdateRate.current_rate,
      };
      try {
        const responseData = await setupService.updateFxCostRate(
          this.selectedUpdateRate.id,
          payload
        );
        if (responseData.data.status_code === 200) {
          this.reloadData();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async getBeneCountryList() {
      this.loader = true;
      try {
        const responseData = await commonService.getCountryBirthList();
        console.log(responseData);
        this.loader = false;
        if (responseData.data.status_code === 200) {
          this.country_options = responseData.data.data.map((i) => {
            return {
              txt: i.country_name,
              val: i.iso_alpha3,
            };
          });
          this.country_ratedata = { ...this.selectedUpdateRate };
          this.country_options.map((ele) => {
            if (ele.txt == this.selectedUpdateRate.country) {
              this.country_ratedata.country = ele.val;
            }
          });
          console.log("getBeneCountryList", this.selectedUpdateRate);
        }
      } catch (e) {
        this.loader = false;
        console.error(e);
      }
    },
    reloadData() {
      this.$refs.Addform.resetValidation();
      this.$emit("closeRateLogs");
      this.$emit("reloadData")
    },
    closeDialog() {
      this.$refs.Addform.resetValidation();
      this.$emit("closeRateLogs");
    },
  },
};
</script>
<style></style>
